<template lang="pug">
  section
    b-container
      h1.mt-0(v-if="this.payout") Payout
      .breadcrumbs.text-muted.small.py-3
        router-link(:to="{name: 'PayoutsHistory'}")
          font-awesome-icon.mr-2(icon="chevron-left")
          span Back to All
      h4 Payout
      .row
        .col-md-6
          content-loader(:height="7", v-if="alert.loading")
          b-card(v-else-if="payout")
            .container
              .row
                .col-6
                  p Summary
                  ul.list-unstyled
                    li
                      span.font-weight-bold Artist
                      span.ml-1 {{ payout.artist_name }}
                    li.pt-3
                      span.font-weight-bold TOTAL
                      span.ml-1 {{ formatRandsCents(payout.amount) }}
                .col-6
                  p Account details
                  p.text-dark {{ payout.bank_account.account_number }}
                    br
                    | {{ payout.bank_account.bank_name }}
                    br
                    | {{ payout.bank_account.type }}
        //.col-md-6
          content-loader(:height="7", v-if="alert.loading")
          b-card(v-else-if="payout && !payout.pop_file_id")
            p Proof of Payment
            span Not yet uploaded
          b-card(v-else="", text-variant="dark")
            p Proof of Payment
            span.text-primary.mt-2
              a.mb-(:href="payout.pop_file_url", target="_blank")
                font-awesome-icon.mr-2(icon="file")
                span PROOF OF PAYMENT

      h4 Items
      content-loader(:height="7", v-if="alert.loading")
      b-card.table-card(v-else-if="payout && payout.customer_order_lines")
        b-table(:items="payout.customer_order_lines", :fields="fields", sort-icon-left, sort-by="id", :sort-desc="true", responsive, borderless)
          template(v-slot:cell(compType)="row")
            b-badge {{ row.item.order_type }}
          template(v-slot:cell(compQuantity)="row") {{ `${row.item.quantity} ${row.item.is_rental?' months':''}` }}
          template(v-slot:cell(compTotal)="row") {{ formatRands(row.item.line_total) }}
          template(v-slot:cell(compCommission)="row") {{ formatRands(row.item.commission) }}
          template(v-slot:cell(compNet)="row") {{ formatRands(row.item.line_total-row.item.commission) }}
</template>

<script>

import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
import router from '@/router';

export default {
  name: 'Payout',
  mixins: [standardMix],
  data() {
    return {
      payout: null,
      popFile: null,
      fields: [
        { key: 'art_name', label: 'Piece' },
        { key: 'compType', label: 'Type' },
        { key: 'compQuantity', label: 'Quantity' },
        { key: 'compTotal', label: 'Line Total' },
        { key: 'compCommission', label: 'Commission' },
        { key: 'compNet', label: 'Net Amount' },
        { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
  },
  methods: {
  },
  async created() {
    if (this.$route.params.payoutId) {
      try {
        this.loading();
        this.payout = await apiService.getPayout(this.$route.params.payoutId);
        this.clear();
      } catch (error) {
        router.push({ name: 'PayoutHistory' });
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/PayoutHistory.vue